export default "\n<app-admin-header></app-admin-header>\n<router-outlet></router-outlet>\n<app-ui-footer></app-ui-footer>"